import axios from 'axios';
import {BASE_URL} from '../constants/GlobalConstants';

class ProductionOrderStatusService{
    getAllProductionOrderStatus(){
        return axios.get(BASE_URL + "/productionStatusList");
    }
}

export default new ProductionOrderStatusService();